import React, { useState } from "react";
import {
    FormSection,
    SectionBody,
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import { I18n } from "aws-amplify";
import * as PropTypes from "prop-types";
import { GeneLifeDict } from "../translate/GeneLife";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import '../Styles/genelife.css';
import '../Styles/subpages.css';
import WgsConsentFormComponent from './WgsConsentFormComponent';


I18n.setLanguage('ja-JP');
I18n.putVocabularies(GeneLifeDict);

const WgsConsentComponent = (props) => {
    const [selectedKit, setSelectedKit] = useState(null);
    const [step, setStep] = useState(1);

    const handleKitSelection = (kit) => {
        setSelectedKit(kit);
    };

    const goToConsent = () => {
        if (selectedKit) {
            setStep(2);
        } else {
            alert("検査キットを選択してください。");
        }
    };

    const handleBack = () => {
        setStep(1);
    }

    return (
    <div>
        <div className="content_wrapper">
            <div className="area_usual">
                <div className="">
                    {props.signOut()}
                    <Header />
                    <div className="container">
                        <img src={require("../images/wgs/wgs_logo.png")} alt="wgs" width="215" />
                        <div className="wgshead_line"></div>
                        <h2 className="wgs_headtitle">ご利用ガイド</h2>
                    </div>
                    <div className="covidmainfield">
                        <div className="contentwrap">
                            <div className="fieldwrap">
                                <h2 className="fieldtitle">検査ID登録の流れ</h2>
                                <ol class="flow-regist -singleline">
                                    <li className="">
                                        <h3>アカウント新規登録</h3>
                                    </li>
                                    <li className="active">
                                        <h3>検査申込同意・検査ID登録</h3>
                                    </li>
                                    <li className="">
                                        <h3>検査試料の採取・返送</h3>
                                    </li>
                                </ol>
                            </div>
             
                        </div>
                    
                    {/* ステップ 1: 検査キット選択 */}
                        {step === 1 && (
                            <div className="contentwrap">
                                <div className="fieldwrap">
                                <h2 className="fieldtitle">該当する項目を選択してください</h2>
                                <p>検査ID・検査パスワードカードなどに記載されている検査IDの頭文字が</p>
                                <div className="cardimg"><img src={require("../images/wgs/wgs_card.png")} alt="wgs" /></div>
                                <div className="selectid">
                                    <div><input type="radio" name="wgs_id" id="wgs_id1" onClick={() => handleKitSelection("kit1")} /><label for="wgs_id1">DW 0</label></div>
                                    <div><input type="radio" name="wgs_id" id="wgs_id2" onClick={() => handleKitSelection("kit2")} /><label for="wgs_id2">DW 6</label></div>
                                </div>
                                <div className="buttonwrap">
                                    <input type="button" name="" value="決定" className="button -wgsc" onClick={goToConsent}/>
                                </div>
                                </div>
                            </div>
                        )}

                    {/* ステップ 2: 同意書の表示 */}
                    {step === 2 && (
                                <div className="contentwrap">
                                    
                                    <div className="">
                                        <div className="wgsform">
                                            <WgsConsentFormComponent selectedKit={selectedKit} />

                                            <FormSection theme={props.theme}>
                                                <SectionBody theme={props.theme}>
                                                    {I18n.get(props.msg)}

                                                </SectionBody>
                                                <div className="buttonwrap">
                                                    <input type="button" name="" value="同意する" className="button -wgsc" onClick={props.doConsent} />
                                                    <input type="button" name="" value="戻る" className="button -lined" onClick={handleBack} />
                                                </div>
                                            </FormSection>
                                        </div>
                                    </div>
                                </div>
                    )}
                </div>
            </div>
            </div>
        </div>
        <Footer />
    </div>
    )
}
export default WgsConsentComponent;

WgsConsentComponent.propTypes = {
    theme: PropTypes.any,
    changeStateFunc: PropTypes.func,
    doConsent: PropTypes.func,
    msg: PropTypes.string,
    wgs: PropTypes.func
}
